import {
  defaultTransactionExportsListFilter,
  transactionExportsListColumnVisibilityOptions,
  defaultTransactionExportsListColumnVisibility,
} from '@utils/tables/transactionExports/transactionExportsListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  showTransactionExportModal: false,
  tableToExport: null,
  filtersForExport: null,
  limit: 25,
  page: 1,
  total: 0,
  selectedFilters: defaultTransactionExportsListFilter,
  columnVisibility: defaultTransactionExportsListColumnVisibility,
  columnVisibilityOptions: transactionExportsListColumnVisibilityOptions,
  transactionExportsTableFilters: {},
  defaultStartDate: null,
  defaultEndDate: null,
};

const transactionExportsTableSlice = createSlice({
  name: 'transactionExportsTable',
  initialState,
  reducers: {
    setTableToExport: (state, { payload }) => {
      state.tableToExport = payload;
    },
    setFiltersForExport: (state, { payload }) => {
      state.filtersForExport = payload;
    },
    setShowTransactionExportModal: (state, { payload }) => {
      state.showTransactionExportModal = payload;
    },
    setDefaultStartDate: (state, { payload }) => {
      state.defaultStartDate = payload;
    },
    setDefaultEndDate: (state, { payload }) => {
      state.defaultEndDate = payload;
    },
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setLimit: (state, { payload }) => {
      state.limit = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setTotal: (state, { payload }) => {
      state.total = payload;
    },
    setTransactionExportsTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { transactionExportsTableFilters } = state;

      const convertedValue = typeof value !== 'object' || value === null ? value : value[0];
      const newProviderTransactionTableFilters = {
        ...transactionExportsTableFilters,
        [codeName]:
          convertedValue === 'true' ? true : convertedValue === 'false' ? false : convertedValue,
      };
      state.transactionExportsTableFilters = newProviderTransactionTableFilters;
    },
    setClearTransactionExportsTableFilters: (state) => {
      state.transactionExportsTableFilters = {};
    },
  },
  extraReducers: {},
});

export const { reducer: transactionExportsTableReducer } = transactionExportsTableSlice;
export const {
  setColumnVisibility,
  setLimit,
  setPage,
  setTotal,
  setTransactionExportsTableFilters,
  setClearTransactionExportsTableFilters,
  setTableToExport,
  setShowTransactionExportModal,
  setFiltersForExport,
  setDefaultStartDate,
  setDefaultEndDate,
} = transactionExportsTableSlice.actions;
